import { createContext, useState } from "react";

export default function Wizard(p: React.PropsWithChildren<{}>) {
  const value = useProvider();
  return <WizardContext value={value}>{p.children}</WizardContext>;
}

export const WizardContext =
  createContext<ReturnType<typeof useProvider>>(null);

function useProvider() {
  const [step, setStep] = useState(0);
  const [stepVariant, setStepVariant] = useState<string>(null);

  function stepForward() {
    setStep((c) => ++c);
    setStepVariant(null);
  }

  function stepBack() {
    setStep((c) => --c);
    setStepVariant(null);
  }

  function stepJump(i: number, variation?: string) {
    setStep(i);
    stepViewVariant(variation);
  }

  function stepViewVariant(variation?: string) {
    setStepVariant(variation || null);
  }

  return {
    step,
    stepVariant,
    stepForward,
    stepBack,
    stepJump,
    stepViewVariant,
  };
}
